export class DOM {
  static freezePageScroll(): void {
    document.documentElement.classList.add('rb-freeze-scroll')
    document.body.classList.add('rb-freeze-scroll')
  }

  static freePageScroll(): void {
    document.documentElement.classList.remove('rb-freeze-scroll')
    document.body.classList.remove('rb-freeze-scroll')
  }
}
